module.exports = __webpack_public_path__ + "9058fd026a2b02eb0f11a83eca9a1cf2.svg";